import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { DependantType } from './dependant-type.interface';
import { ApiResource } from '@/core/models/api-resource.interface';

export class DependantTypeService {
   async getDependantTypes() {
      return await http.get<ApiResource<Array<DependantType>>>(`/dependant_types`, cacheFirstConfig).then((response) => response.data);
   }
}
